import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/files.json';
import ar from './i18n/ar/files.json';

registerFeatureI18n('files', { en, ar });

export { FilesPage } from './FilesPage';
